/* A search icon that expands in place into an input.
 * On mobile widths (matching `useDeviceType`), the expanded input takes the rest of its row. */

.toggleable-search-field {
  display: inline-flex;
  align-items: center;

  /* Matches Tailwind's `md` screen size */
  @media (width <= 768px) {
    &.expanded {
      flex: 1;
      min-width: 0;
    }
  }
}
